/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio manager API
 * API for tracking portfolio management
 *
 * OpenAPI document version: 1.0.0
 *
 */
import { useMemo } from 'react';
import { queryOptions, useMutation, useQuery, } from '@tanstack/react-query';
import { OrganizationsApi, } from '@portfolio-manager/sdk';
import { useApiConfiguration } from '../../api-configuration-context.js';
export const organizationsKeys = {
    all: ['organizations'],
    addMember: () => ['organizations', 'addMember'],
    createOrganization: () => ['organizations', 'createOrganization'],
    getMember: (params) => ['organizations', 'getMember', params],
    getMembers: (params) => ['organizations', 'getMembers', params],
    getOrganization: (params) => ['organizations', 'getOrganization', params],
    removeMember: () => ['organizations', 'removeMember'],
};
export function useOrganizationsApi() {
    const configuration = useApiConfiguration();
    return useMemo(() => new OrganizationsApi(configuration), [configuration]);
}
export function useOrganizationsAddMember(options) {
    const api = useOrganizationsApi();
    return useMutation({
        mutationKey: organizationsKeys.addMember(),
        mutationFn: (params) => api.addMember(params),
        ...options,
    });
}
export function useOrganizationsCreateOrganization(options) {
    const api = useOrganizationsApi();
    return useMutation({
        mutationKey: organizationsKeys.createOrganization(),
        mutationFn: (params) => api.createOrganization(params),
        ...options,
    });
}
export const organizationsGetMemberQueryOptions = (api, params) => queryOptions({
    queryKey: organizationsKeys.getMember(params),
    queryFn: ({ signal }) => api.getMember(params, { signal }),
});
export function useOrganizationsGetMember(params, options) {
    const api = useOrganizationsApi();
    return useQuery({ ...organizationsGetMemberQueryOptions(api, params), ...options });
}
export const organizationsGetMembersQueryOptions = (api, params) => queryOptions({
    queryKey: organizationsKeys.getMembers(params),
    queryFn: ({ signal }) => api.getMembers(params, { signal }),
});
export function useOrganizationsGetMembers(params, options) {
    const api = useOrganizationsApi();
    return useQuery({ ...organizationsGetMembersQueryOptions(api, params), ...options });
}
export const organizationsGetOrganizationQueryOptions = (api, params) => queryOptions({
    queryKey: organizationsKeys.getOrganization(params),
    queryFn: ({ signal }) => api.getOrganization(params, { signal }),
});
export function useOrganizationsGetOrganization(params, options) {
    const api = useOrganizationsApi();
    return useQuery({ ...organizationsGetOrganizationQueryOptions(api, params), ...options });
}
export function useOrganizationsRemoveMember(options) {
    const api = useOrganizationsApi();
    return useMutation({
        mutationKey: organizationsKeys.removeMember(),
        mutationFn: (params) => api.removeMember(params),
        ...options,
    });
}
//# sourceMappingURL=organizations-api.js.map